import { render, staticRenderFns } from "./ProfileReputation.vue?vue&type=template&id=796d1b15&"
import script from "./ProfileReputation.vue?vue&type=script&lang=js&"
export * from "./ProfileReputation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports